import { render, staticRenderFns } from "./rupin._.default.vue?vue&type=template&id=0812faf7&slot=start-instructions&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports